module.exports = __webpack_public_path__ + "lendo.4dfb6720a4a60513f0cf.svg";